export const LOCAL_STORAGE_MODELS_KEY = '@doris:models'
export const LOCAL_STORAGE_MODELS_KEY_V2 = '@doris:models-v2'
